export enum ChatBotActionType {
    ADD_ESD = 'chatbot:add:esd',
    CLEAR_HISTORY = 'chatbot:clear:history',
    LLM_MODEL = 'chatbot:llm:model',
    UPLOAD_FILE = 'chatbot:upload:file',
    TRIGGER_REPLY = 'chatbot:trigger:reply',
    UNKNOWN = 'chatbot:unknown',
}

export interface ChatBotAction {
    actionType: ChatBotActionType;
    payload?: any;
}